import { getSignInAuth } from '@/config/auth';
export default async function getCurrentAccessToken() {
    const session = await getSignInAuth()
        .currentSession()
        .catch(() => null);
    if (!session) {
        return null;
    }
    return session.getAccessToken().getJwtToken();
}
